const React = require("react");
const ExitToApp = require('@material-ui/icons/ExitToApp').default;
const {loadingReconnect$} = require('../../../../../../api/_auth');
const {account$} = require("../../../../../../emitters/account");
const withState = require("../../../../../../utils/withState");
const Loading = require("../../../../../dumb/Loading");

module.exports = withState(() => {
  return (state, props) => {
    const account = state.account || {};

    return (
      <div className={'h140 h80@m layoutRow fhaB fhaC.hidden-menu fvaC' + (props.isHiddenMenu ? ' hidden-menu' : '')}>
        <div className="layoutRow fhaS fvaC">
          {state.loadingReconnect ? (
            <>
              <div className="sq50 rlv c0>.CircularProgress">
                <Loading/>
              </div>
              <div className="pl15">Reconnection...</div>
            </>
          ) : null}
        </div>
        {
          account ? (
            <div className={'layoutRow fhaS fvaC cF.hidden-menu>1' + (props.isHiddenMenu ? ' hidden-menu' : '')}>
              <div
                className="pr15 f12 fw3 lh lts0em c0"
              >{account.username || ''}</div>
              <a
                className="f16 fw3 lh lts0em c5B47FF ttU dn o70:h"
                onClick={account$.signOut}
              >
                {props.isHiddenMenu ? <ExitToApp /> : 'Logout'}
              </a>
            </div>
          ) : null
        }
      </div>
    )
  }
}, {
  loadingReconnect: loadingReconnect$,
  // account: account$
})
